import { render, staticRenderFns } from "./server-detail-menu.vue?vue&type=template&id=e3e86ee2&scoped=true&"
import script from "./server-detail-menu.vue?vue&type=script&lang=js&"
export * from "./server-detail-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e86ee2",
  null
  
)

export default component.exports